import { render, staticRenderFns } from "./CoberturaCliente.vue?vue&type=template&id=3f1f7331&scoped=true&"
import script from "./CoberturaCliente.vue?vue&type=script&lang=js&"
export * from "./CoberturaCliente.vue?vue&type=script&lang=js&"
import style0 from "./CoberturaCliente.vue?vue&type=style&index=0&id=3f1f7331&scoped=true&lang=css&"
import style1 from "./CoberturaCliente.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f7331",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VRow})
